/**
 * Returns whether an object contains a given property.
 */
function hasOwnProperty(obj, prop) {
  if (typeof obj === 'undefined' || obj === null) return false;
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export { hasOwnProperty as h };
//# sourceMappingURL=hasOwnProperty-BBa9GG4X-BBa9GG4X.js.map
